import React from "react";

function localDateExcelCell(options, column, gridCell) {

}

function localDateCell(config) {
  config.dataType = "date";
  config.alignment = "center";
}

export {localDateCell, localDateExcelCell}
